export default __webpack_public_path__ + "static/media/Imagem1.e2ec536e.png";